<template>
  <vs-row
    vs-type="flex"
    vs-justify="flex-start"
    vs-align="flex-start"
    vs-w="12"
  >
    <vs-card >
        <!-- {{subject_ids}} -->
        <!-- <pre>{{selected}}</pre> -->
      <vs-table multiple v-model="selected" :data="AssignmentList">
        <template slot="header">
          <!-- {{assignment_type_id}} -->
          <!-- <h3 v-if="assignment_type_id == 1">Question List</h3> -->
          <h3 v-if="assignment_type_id == 2">Homework List</h3>
          <h3 v-if="assignment_type_id == 3">Report List</h3>
          <h3 v-if="assignment_type_id == 4">Exam List</h3>
        </template>

        <template slot="thead">
          <vs-th>Name</vs-th>
          <vs-th>Description</vs-th>
          <vs-th>Type</vs-th>
          <vs-th>Subject</vs-th>
          <vs-th>No.of Questions</vs-th>
          <vs-th>No.of Files</vs-th>
          <vs-th>Tags</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              {{ data[indextr].title }}
            </vs-td>

            <vs-td>
              {{ data[indextr].description }}
            </vs-td>

            <vs-td>
              {{ data[indextr].assignment_type }}
            </vs-td>

            <vs-td>
              {{ data[indextr].subject.subject_name }}
            </vs-td>
            <vs-td>
              {{ data[indextr].questions.length }}
            </vs-td>
            <vs-td>
              {{ fileCountArr[indextr] }}
            </vs-td>
            <vs-td>
              <span
                v-for="(tag, tagindex) in data[indextr].tags"
                :key="tagindex"
              >
                {{ tag.tag.name }}
                <span v-if="tagindex + 1 < data[indextr].tags.length">, </span>
              </span>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>

      <vs-divider />

      <vs-button v-if="query_page.has_next" @click="loadMoreData" style="float:right">Load More Data</vs-button>

      <vs-button class="my-4" @click="exportAssignmentList">Export to Class</vs-button>
    </vs-card>
  </vs-row>
</template>
<script>
import {mapGetters} from 'vuex'
import vSelect from 'vue-select'


import {
  listAssignment
} from '@/api/assignment-question'


export default {
  name: 'AssignmentModelListView',
  props: {
    'assignment_type_id':{

    },
    'type':{

    }, 
    'subject_id':{
      type:Array,
      required:true,
      default:() => []
    }
    
  },
  
  components: {
    vSelect
  },

  mounted () {
    console.log(this.assignment_type_id)
    this.payload = { 
      assignment_type_id: this.assignment_type_id,
      subject_id: this.subject_id
    }

    if (this.subject_id.length > 0) {
      this.fetchAssignmentList(this.payload)
    }
  },
    

  data () {
    return {
      fileCountArr:[],
      selected: [],

      AssignmentList: [],
      query_page:{
        'total': '',
        'limit': 10,
        'has_next': false,
        'current_page': 1,
        'next_page_url': null,
        'previous_page_url': ''
      }
    
      
    }
  },
  watch:{

    get_homework_subject_id () {
      const data = this.get_homework_subject_id
      const payload = {
        assignment_type_id:this.assignment_type_id,
        subject_id:data
      }
      
      this.fetchAssignmentList(payload)
      // fetchAssignmentListconst
    }
  },

  computed: { 
    ...mapGetters(
      ['get_homework_subject_id']
    ),
    selectedLength () {
      if (this.selected.length > 1) {
        return true
      }
    }
  },
  methods: {
    noOfFilesInEachAssignment (AssignmentList) {
      for (let i = 0; i < AssignmentList.length; i++) {
        const questions = AssignmentList[i].questions
        let count = 0
        for (let j = 0; j < questions.length; j++) {
          if (questions[j].files.length > 0) {
            count += questions[j].files.length
          }
        }
        this.fileCountArr.push(count)
      }
      //return this.fileCountArr;
    },
    openEditView (assignment) {
      
      //setTimeout(function(){
      this.$router.push({
        name: 'QuestionsV2',
        params: { assignment_details: assignment }
      })
      //},3000)
    },

    async fetchAssignmentList (payload) {
      try {
        this.$vs.loading({
          text:'Fetching Data please wait ...'
        })

        const customerId = this.$store.getters.customerId
        const data = await listAssignment(payload, customerId, this.query_page.current_page)
        
        
        this.AssignmentList = data.data.data.assignmentlist
        this.noOfFilesInEachAssignment(this.AssignmentList)
        this.query_page = data.data.data.meta
      } catch (error) {
        
      } finally {
        this.$vs.loading.close()
      }
    },
    async loadMoreData () {

      try {
        this.$vs.loading({
          text:'Fetching Data please wait ...'
        })
        const customerId = this.$store.getters.customerId

        //   this.payload = { assignment_type_id: this.assignment_type_id }
        const { data } = await listAssignment(this.payload, customerId,  this.query_page.current_page + 1)
        // this.question_details = [...this.question_details, data.data.question_details]
      

        this.AssignmentList.push(...data.data.assignmentlist)


        this.query_page = data.data.meta

        
      } catch (error) {
        this.$vs.loading.close()
      } finally {
        this.$vs.loading.close()

      }

    },
    exportAssignmentList () {
      // 
      if (this.selected.length) {
        const obj = this.selected
        this.$emit('getAssignmentData', obj)

      }


    },
    editSidebar () {
      this.$emit('editSidebar')
    },
    exportAssignment () {
      
    }
  }
}
</script>
